import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import withIntl from '../lib/withIntl';

function FormattedHTMLMessage({intl, id, ...props}) {
  const prepareProps = () => {
    const message = intl.formatMessage({id});
    const newProps = {...props};

    if (message.includes('{br}')) {
      newProps.values = {
        ...newProps.values,
        br: <br />,
      };
    }

    if (message.includes('<b>')) {
      newProps.values = {
        ...newProps.values,
        // eslint-disable-next-line react/no-unstable-nested-components
        b: (chunks) => <b>{chunks}</b>,
      };
    }

    if (message.includes('<i>')) {
      newProps.values = {
        ...newProps.values,
        // eslint-disable-next-line react/no-unstable-nested-components
        i: (chunks) => <i>{chunks}</i>,
      };
    }

    if (message.includes('<strong>')) {
      newProps.values = {
        ...newProps.values,
        // eslint-disable-next-line react/no-unstable-nested-components
        strong: (chunks) => <strong>{chunks}</strong>,
      };
    }

    if (message.includes('<div')) {
      newProps.values = {
        ...newProps.values,
        // eslint-disable-next-line react/no-unstable-nested-components
        div: (chunks) => <div>{chunks}</div>,
      };
    }

    if (message.includes('<h3>')) {
      newProps.values = {
        ...newProps.values,
        // eslint-disable-next-line react/no-unstable-nested-components
        h3: (chunks) => <h3>{chunks}</h3>,
      };
    }

    if (message.includes('<h4>')) {
      newProps.values = {
        ...newProps.values,
        // eslint-disable-next-line react/no-unstable-nested-components
        h4: (chunks) => <h4>{chunks}</h4>,
      };
    }

    return newProps;
  };

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <FormattedMessage id={id} {...prepareProps()} />;
}

FormattedHTMLMessage.propTypes = {
  intl: PropTypes.object.isRequired,
  id: PropTypes.any.isRequired,
};

export default withIntl(FormattedHTMLMessage);
